import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, AppThunk } from "@/app/types";
import {
  fetchProductReport,
  ProductReportData,
} from "@/modules/productStorefront/features/ProductReport/api/productReportApi";

interface ProductReportState {
  reportData: ProductReportData | null;
  loading: boolean;
  error: string | null;
}

const initialState: ProductReportState = {
  reportData: null,
  loading: false,
  error: null,
};

const productReportSlice = createSlice({
  name: "productReport",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setReportData(state, action: PayloadAction<ProductReportData | null>) {
      state.reportData = action.payload;
    },
    resetProductReportState(state) {
      state.reportData = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export default productReportSlice.reducer;

export const {
  setLoading,
  setError,
  setReportData,
  resetProductReportState,
} = productReportSlice.actions;

export const fetchProductReportAction =
  (params: { startDate?: string; endDate?: string }): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(null));
    try {
      const result = await fetchProductReport(params);
      dispatch(setReportData(result.data));
    } catch (error) {
      const message =
        error instanceof Error
          ? error.message
          : "Failed to fetch product report data.";
      dispatch(setError(message));
    } finally {
      dispatch(setLoading(false));
    }
  };
